import { useEffect } from 'react';

// window.Alex e injetado pelo widget do meu-agente (canal web_widget). No-op se ausente.
declare global {
  interface Window {
    Alex?: { nudge?: (payload: { categoria: string; motivo: string }) => void };
  }
}

/**
 * Espelha o hook do cardapio.html do OndePedido: apos 60s de inatividade,
 * chama window.Alex.nudge UMA vez por sessao (no-op total se o widget do
 * meu-agente ainda nao injetou window.Alex). Sem window.Alex, zero efeito/erro.
 */
export function useAlexNudge(categoria: string = 'seguros'): void {
  useEffect(() => {
    const IDLE_MS = 60000;
    let nudged = false;
    let timer: ReturnType<typeof setTimeout> | undefined;

    const fire = () => {
      if (nudged) return;
      if (window.Alex && typeof window.Alex.nudge === 'function') {
        nudged = true;
        try {
          window.Alex.nudge({ categoria, motivo: 'idle_60s_cotacao' });
        } catch {
          // no-op: nunca quebra a pagina por causa do widget
        }
      }
    };

    const rearm = () => {
      if (nudged) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(fire, IDLE_MS);
    };

    let lastScroll = 0;
    const onScroll = () => {
      const now = new Date().getTime();
      if (now - lastScroll < 250) return; // throttle
      lastScroll = now;
      rearm();
    };

    const activityEvents = ['click', 'keydown', 'input', 'touchstart'];
    activityEvents.forEach((ev) => window.addEventListener(ev, rearm, { passive: true }));
    window.addEventListener('scroll', onScroll, { passive: true });

    rearm(); // arma o timer inicial

    return () => {
      if (timer) clearTimeout(timer);
      activityEvents.forEach((ev) => window.removeEventListener(ev, rearm));
      window.removeEventListener('scroll', onScroll);
    };
  }, [categoria]);
}
